"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CursorPaginatedResponse = exports.CursorPaginationContract = exports.Pagination = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
class Pagination {
    constructor(json = {}) {
        this.offset = json.offset ? parseInt(json.offset, 10) : 0;
        this.limit = json.limit ? parseInt(json.limit, 10) : 1000;
    }
}
exports.Pagination = Pagination;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Type)(() => Number)
], Pagination.prototype, "offset", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.Min)(0),
    (0, class_transformer_1.Type)(() => Number)
], Pagination.prototype, "limit", void 0);
class CursorPaginationContract {
}
exports.CursorPaginationContract = CursorPaginationContract;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CursorPaginationContract.prototype, "nextCursor", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)()
], CursorPaginationContract.prototype, "prevCursor", void 0);
class CursorPaginatedResponse {
}
exports.CursorPaginatedResponse = CursorPaginatedResponse;
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true })
], CursorPaginatedResponse.prototype, "data", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Type)(() => CursorPaginationContract)
], CursorPaginatedResponse.prototype, "pagination", void 0);
//# sourceMappingURL=Pagination.js.map